import { Stack, Select, MenuItem, InputLabel, FormControl, OutlinedInput } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { useState } from 'react';
import { ReportFilterKey, ReportFilterValue } from 'src/type/report';

type Props = {
  date: Dayjs | null;
  handleFilters: (name: ReportFilterKey, value: ReportFilterValue) => void;
};

type Weeks = { startOfWeek: Dayjs; endOfWeek: Dayjs };

export default function ReportWeeklyFilters({ date, handleFilters }: Props) {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(date);
  const [weekOptions, setWeekOptions] = useState<Weeks[]>([]);
  const [selectedWeek, setSelectedWeek] = useState<string>('');

  const handleSetDate = (inputDate: Dayjs | null) => {
    if (!inputDate) return;

    const weeks = Array<Weeks>();
    const startOfMonth = inputDate.startOf('month');
    const endOfMonth = inputDate.endOf('month');

    let currentWeekStart = startOfMonth;

    while (currentWeekStart.isBefore(endOfMonth) || currentWeekStart.isSame(endOfMonth, 'day')) {
      const currentWeekEnd = currentWeekStart.endOf('week');

      weeks.push({
        startOfWeek: currentWeekStart,
        endOfWeek: currentWeekEnd.isAfter(endOfMonth) ? endOfMonth : currentWeekEnd,
      });

      currentWeekStart = currentWeekStart.add(1, 'week').startOf('week');
    }

    setSelectedDate(inputDate);
    setWeekOptions(weeks);
  };

  const handleSelectWeek = (week: string) => {
    setSelectedWeek(week);
    const weeks = weekOptions?.[parseInt(week || '0', 10)];
    if (weeks) {
      handleFilters('startDate', weeks.startOfWeek);
      handleFilters('endDate', weeks.endOfWeek);
    }
  };

  return (
    <Stack spacing={2}>
      <DatePicker
        label="เดือน"
        value={selectedDate}
        onChange={handleSetDate}
        format="MM/YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
          },
        }}
        openTo="month"
        views={['year', 'month']}
      />
      <FormControl
        sx={{
          flexShrink: 0,
          width: 1,
        }}
      >
        <InputLabel>สัปดาห์</InputLabel>
        <Select
          value={selectedWeek}
          onChange={(e) => handleSelectWeek(e.target.value)}
          input={<OutlinedInput label="สัปดาห์" />}
          disabled={!weekOptions.length}
        >
          {weekOptions.map((option, i) => (
            <MenuItem key={i} value={`${i}`}>
              {option.startOfWeek.format('DD/MM/YYYY')} - {option.endOfWeek.format('DD/MM/YYYY')}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
